import React from 'react';

import { Image } from '$partials/media';
import BackgroundVideo from '$partials/media/background-video';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

const COLLAPSE_PADDING_TYPENAMES = ['BvaModuleQuote', 'BvaModuleStatement', 'BvaModuleFeature', 'BvaModuleSingleImage'];

/**
 * @type {import('$types/components/partials/modules.d.ts').ModuleSingleImage}
 */
const ModuleSingleImage = ({
    media = {},
    media2 = {},
    layout,
    // @ts-ignore — injected by dispatcher, not part of the CMS fragment
    nextTypename,
    // @ts-ignore — injected by dispatcher, not part of the CMS fragment
    isArticlePage,
    // @ts-ignore — injected by dispatcher, not part of the CMS fragment
    previousTypename,
}) => {
    if (!media) { return null; }

    const twoMedia = media2?.src && media?.src;
    const collapseBottomPadding = COLLAPSE_PADDING_TYPENAMES.includes(nextTypename);
    const collapseTopToGap = previousTypename === 'BvaModuleSingleImage';

    const fwTopClass = collapseTopToGap ? 'pt-16' : 'pt-40';
    const fwBottomClass = collapseBottomPadding ? 'pb-0' : 'pb-40';

    let contextTopClass = '';
    if (collapseTopToGap) { contextTopClass = ' pt-16'; }
    else if (isArticlePage) { contextTopClass = ' pt-40'; }

    let hwBottomClass = '';
    if (isArticlePage) { hwBottomClass = collapseBottomPadding ? ' pb-0' : ' pb-40'; }

    let tmBottomClass = '';
    if (collapseBottomPadding) { tmBottomClass = ' pb-0'; }
    else if (isArticlePage) { tmBottomClass = ' pb-40'; }

    if (layout === 'Full width' && !twoMedia) {
        return (
            <section className={`relative bg-white ${fwTopClass} ${fwBottomClass}`}>
                <div className='layout-container layout-site-outer-padding'>
                    <figure className='w-full rounded overflow-hidden'>

                        {media?.contentType?.includes('video/') ? (
                            <BackgroundVideo
                                className='rounded object-cover w-full h-full'
                                containerClassName='w-full rounded '
                                src={media?.src}/>
                        ) : (
                            <Image
                                className='rounded object-cover h-full'
                                containerClassName='w-full rounded '
                                src={media?.src} />
                        )}
                    </figure>
                </div>
            </section>
        );
    } else if (layout === 'Half width' && !twoMedia) {
        return (
            <section className={`relative bg-white${contextTopClass}${hwBottomClass}`}>
                <div className='layout-container layout-site-outer-padding'>
                    <div className='col-wrapper flex sm:flex-row flex-col'>

                        <div className='col-padding sm:w-6/12 hidden md:block' />
                        <figure className='col-padding sm:w-6/12 rounded overflow-hidden'>

                            {media?.contentType?.includes('video/') ? (
                                <BackgroundVideo
                                    className='rounded object-cover w-full h-full'
                                    containerClassName='w-full rounded '
                                    src={media?.src}/>
                            ) : (
                                <Image
                                    className='rounded object-cover h-full'
                                    containerClassName='w-full rounded '
                                    src={media?.src} />
                            )}
                        </figure>
                    </div>
                </div>
            </section>
        );
    } else if (twoMedia) {
        return (
            <section className={`relative bg-white${contextTopClass}${tmBottomClass}`}>
                <div className='layout-container layout-site-outer-padding'>
                    <div className='col-wrapper flex sm:flex-row flex-col'>

                        <figure className='col-padding sm:w-6/12 rounded overflow-hidden'>

                            {media?.contentType?.includes('video/') ? (
                                <BackgroundVideo
                                    className='rounded object-cover w-full h-full'
                                    containerClassName='w-full rounded '
                                    src={media?.src}/>
                            ) : (
                                <Image
                                    className='rounded object-cover h-full'
                                    containerClassName='w-full rounded '
                                    src={media?.src} />
                            )}
                        </figure>
                        <figure className='col-padding sm:w-6/12 rounded overflow-hidden'>

                            {media2?.contentType?.includes('video/') ? (
                                <BackgroundVideo
                                    className='rounded object-cover w-full h-full'
                                    containerClassName='w-full rounded '
                                    src={media2?.src}/>
                            ) : (
                                <Image
                                    className='rounded object-cover h-full'
                                    containerClassName='w-full rounded '
                                    src={media2?.src} />
                            )}
                        </figure>
                    </div>
                </div>
            </section>
        );
    }
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default ModuleSingleImage;
